module.exports = __webpack_public_path__ + "img/t-matrix.d75afe4f.png";